// Dropdown Bimding - GetCapacityVsDemandFilterDDList
export const FETCH_CAPACITY_REPORT_DDLIST_REQUEST = 'FETCH_CAPACITY_REPORT_DDLIST_REQUEST';
export const FETCH_CAPACITY_REPORT_DDLIST_SUCCESS = 'FETCH_CAPACITY_REPORT_DDLIST_SUCCESS';
export const FETCH_CAPACITY_REPORT_DDLIST_FAILURE = 'FETCH_CAPACITY_REPORT_DDLIST_FAILURE';

//Binding Report List 
export const FETCH_CAPACITYVsDEMAND_REPORT_REQUEST = 'FETCH_CAPACITYVsDEMAND_REPORT_REQUEST';
export const FETCH_CAPACITYVsDEMAND_REPORT_SUCCESS = 'FETCH_CAPACITYVsDEMAND_REPORT_SUCCESS';
export const FETCH_CAPACITYVsDEMAND_REPORT_FAILURE = 'FETCH_CAPACITYVsDEMAND_REPORT_FAILURE';

//Fetch Available shift data
export const FETCH_AVAILABLE_SHIFT_REQUEST = 'FETCH_AVAILABLE_SHIFT_REQUEST';
export const FETCH_AVAILABLE_SHIFT_SUCCESS = 'FETCH_AVAILABLE_SHIFT_SUCCESS';
export const FETCH_AVAILABLE_SHIFT_FAILURE = 'FETCH_AVAILABLE_SHIFT_FAILURE';

//Fetch Available RPCE Filter DDList
export const FETCH_AVAILABLE_SHIFT_FILTERDDLIST_REQUEST = 'FETCH_AVAILABLE_SHIFT_FILTERDDLIST_REQUEST';
export const FETCH_AVAILABLE_SHIFT_FILTERDDLIST_SUCCESS = 'FETCH_AVAILABLE_SHIFT_FILTERDDLIST_SUCCESS';
export const FETCH_AVAILABLE_SHIFT_FILTERDDLIST_FAILURE = 'FETCH_AVAILABLE_SHIFT_FILTERDDLIST_FAILURE';

//Fetch Legend Data
export const FETCH_AVAILABLESHIFT_LEGEND_REQUEST = 'FETCH_AVAILABLESHIFT_LEGEND_REQUEST';
export const FETCH_AVAILABLESHIFT_LEGEND_SUCCESS = 'FETCH_AVAILABLESHIFT_LEGEND_SUCCESS';
export const FETCH_AVAILABLESHIFT_LEGEND_FAILURE = 'FETCH_AVAILABLESHIFT_LEGEND_FAILURE';

//Fetch Available Shift RPCE Data
export const FETCH_AVAILABLE_SHIFT_RPCE_REQUEST = 'FETCH_AVAILABLE_SHIFT_RPCE_REQUEST';
export const FETCH_AVAILABLE_SHIFT_RPCE_SUCCESS = 'FETCH_AVAILABLE_SHIFT_RPCE_SUCCESS';
export const FETCH_AVAILABLE_SHIFT_RPCE_FAILURE = 'FETCH_AVAILABLE_SHIFT_RPCE_FAILURE';

//Fetch Available Shift Worklist Data
export const FETCH_AVAILABLE_WORKLISTDATA_REQUEST = 'FETCH_AVAILABLE_WORKLISTDATA_REQUEST'; 
export const FETCH_AVAILABLE_WORKLISTDATA_SUCCESS = 'FETCH_AVAILABLE_WORKLISTDATA_SUCCESS';
export const FETCH_AVAILABLE_WORKLISTDATA_FAILURE = 'FETCH_AVAILABLE_WORKLISTDATA_FAILURE';

//Fetch RPCE DATA in CapsVsDemand tab
export const FETCH_RPCE_DATA_CAPSVSDEMAND_REQUEST = 'FETCH_RPCE_DATA_CAPSVSDEMAND_REQUEST';
export const FETCH_RPCE_DATA_CAPSVSDEMAND_SUCCESS = 'FETCH_RPCE_DATA_CAPSVSDEMAND_SUCCESS';
export const FETCH_RPCE_DATA_CAPSVSDEMAND_FAILURE = 'FETCH_RPCE_DATA_CAPSVSDEMAND_FAILURE';

//Fetch Worklist DATA in CapsVsDemand tab
export const FETCH_WORKLIST_DATA_CAPSVSDEMAND_REQUEST = 'FETCH_WORKLIST_DATA_CAPSVSDEMAND_REQUEST';
export const FETCH_WORKLIST_DATA_CAPSVSDEMAND_SUCCESS = 'FETCH_WORKLIST_DATA_CAPSVSDEMAND_SUCCESS';
export const FETCH_WORKLIST_DATA_CAPSVSDEMAND_FAILURE = 'FETCH_WORKLIST_DATA_CAPSVSDEMAND_FAILURE';

//Fetch RPCE Details in CapsVsDemand tab on popup
export const FETCH_CAPACITY_HOVER_DETAILS_REQUEST = 'FETCH_CAPACITY_HOVER_DETAILS_REQUEST';
export const FETCH_CAPACITY_HOVER_DETAILS_SUCCESS = 'FETCH_CAPACITY_HOVER_DETAILS_SUCCESS';
export const FETCH_CAPACITY_HOVER_DETAILS_FAILURE = 'FETCH_CAPACITY_HOVER_DETAILS_FAILURE';

//Fetch Worklist Details in CapsVsDemand tab on popup
export const FETCH_WORKLIST_HOVER_DETAILS_REQUEST = 'FETCH_WORKLIST_HOVER_DETAILS_REQUEST';
export const FETCH_WORKLIST_HOVER_DETAILS_SUCCESS = 'FETCH_WORKLIST_HOVER_DETAILS_SUCCESS';
export const FETCH_WORKLIST_HOVER_DETAILS_FAILURE = 'FETCH_WORKLIST_HOVER_DETAILS_FAILURE';

//Fetch Capacity Vs Demand Get By Id Details
export const FETCH_GETBY_ID_DETAILS_REQUEST = 'FETCH_GETBY_ID_DETAILS_REQUEST';
export const FETCH_GETBY_ID_DETAILS_SUCCESS = 'FETCH_GETBY_ID_DETAILS_SUCCESS';
export const FETCH_GETBY_ID_DETAILS_FAILURE = 'FETCH_GETBY_ID_DETAILS_FAILURE';

//Fetch Notes Details
export const FETCH_CAPSVSDEMAND_NOTES_DETAILS_REQUEST = 'FETCH_CAPSVSDEMAND_NOTES_DETAILS_REQUEST';
export const FETCH_CAPSVSDEMAND_NOTES_DETAILS_SUCCESS = 'FETCH_CAPSVSDEMAND_NOTES_DETAILS_SUCCESS';
export const FETCH_CAPSVSDEMAND_NOTES_DETAILS_FAILURE = 'FETCH_CAPSVSDEMAND_NOTES_DETAILS_FAILURE';

//Save Notes Details
export const SAVE_CAPSVSDEMAND_NOTES_REQUEST = 'SAVE_CAPSVSDEMAND_NOTES_REQUEST';
export const SAVE_CAPSVSDEMAND_NOTES_SUCCESS = 'SAVE_CAPSVSDEMAND_NOTES_SUCCESS';
export const SAVE_CAPSVSDEMAND_NOTES_FAILURE = 'SAVE_CAPSVSDEMAND_NOTES_FAILURE';

//Pulish Caps Vs Demnad Report
export const PUBLISH_CAPSVSDEMAND_REPORT_REQUEST = 'PUBLISH_CAPSVSDEMAND_REPORT_REQUEST';
export const PUBLISH_CAPSVSDEMAND_REPORT_SUCCESS = 'PUBLISH_CAPSVSDEMAND_REPORT_SUCCESS';
export const PUBLISH_CAPSVSDEMAND_REPORT_FAILURE = 'PUBLISH_CAPSVSDEMAND_REPORT_FAILURE';

//Export on RPCE data in Available shift
export const EXPORT_RPCE_DATA_AVAILABLESHIFT_REQUEST = 'EXPORT_RPCE_DATA_AVAILABLESHIFT_REQUEST';
export const EXPORT_RPCE_DATA_AVAILABLESHIFT_SUCCESS = 'EXPORT_RPCE_DATA_AVAILABLESHIFT_SUCCESS';
export const EXPORT_RPCE_DATA_AVAILABLESHIFT_FAILURE = 'EXPORT_RPCE_DATA_AVAILABLESHIFT_FAILURE';

//Export on Worklist data in Available shift
export const EXPORT_WORKLIST_DATA_AVAILABLESHIFT_REQUEST = 'EXPORT_WORKLIST_DATA_AVAILABLESHIFT_REQUEST';
export const EXPORT_WORKLIST_DATA_AVAILABLESHIFT_SUCCESS = 'EXPORT_WORKLIST_DATA_AVAILABLESHIFT_SUCCESS';
export const EXPORT_WORKLIST_DATA_AVAILABLESHIFT_FAILURE = 'EXPORT_WORKLIST_DATA_AVAILABLESHIFT_FAILURE';

//Export RPCE Data in Caps Vs Demnad tab
export const EXPORT_RPCE_CAPSVSDEMAND_REQUEST = 'EXPORT_RPCE_CAPSVSDEMAND_REQUEST';
export const EXPORT_RPCE_CAPSVSDEMAND_SUCCESS = 'EXPORT_RPCE_CAPSVSDEMAND_SUCCESS';
export const EXPORT_RPCE_CAPSVSDEMAND_FAILURE = 'EXPORT_RPCE_CAPSVSDEMAND_FAILURE';

//Export Worklist Data in Caps Vs Demnad tab
export const EXPORT_WORKLIST_CAPSVSDEMAND_REQUEST = 'EXPORT_WORKLIST_CAPSVSDEMAND_REQUEST';
export const EXPORT_WORKLIST_CAPSVSDEMAND_SUCCESS = 'EXPORT_WORKLIST_CAPSVSDEMAND_SUCCESS';
export const EXPORT_WORKLIST_CAPSVSDEMAND_FAILURE = 'EXPORT_WORKLIST_CAPSVSDEMAND_FAILURE';

//Delete Caps Vs Demnad Report
export const DELETE_CAPSVSDEMAND_REPORT_REQUEST = 'DELETE_CAPSVSDEMAND_REPORT_REQUEST';
export const DELETE_CAPSVSDEMAND_REPORT_SUCCESS = 'DELETE_CAPSVSDEMAND_REPORT_SUCCESS';
export const DELETE_CAPSVSDEMAND_REPORT_FAILURE = 'DELETE_CAPSVSDEMAND_REPORT_FAILURE';

// Export the Caps Vs Demnad Report
export const EXPORT_CAPSVSDEMAND_REPORT_REQUEST = 'EXPORT_CAPSVSDEMAND_REPORT_REQUEST';
export const EXPORT_CAPSVSDEMAND_REPORT_SUCCESS = 'EXPORT_CAPSVSDEMAND_REPORT_SUCCESS';
export const EXPORT_CAPSVSDEMAND_REPORT_FAILURE = 'EXPORT_CAPSVSDEMAND_REPORT_FAILURE';